import { Accordion, Card, Grid, InputText } from "#/atoms";
import { FC, memo } from "react";

import { DESKTOP_SPACING } from "@/theme";
import { GenericServiceProps } from "./OrderService.interface";
import { HeadingIcon } from "#/molecules";
import OrderServiceHeader from "./OrderServiceHeader";

const GenericService: FC<GenericServiceProps> = ({
  amount,
  externalUrl,
  isAdmin,
  label,
  name,
  notificationMessage,
  onAskToChangeWorker,
  onChangeLabel,
  onChangeUrl,
  onNotifyCustomer,
  onRecordVirtualTour,
  selectedWorkerName,
  serviceId,
  type
}) => {
  const accordionState = 'open';

  return (
    <Card>
        <Accordion
          header={<HeadingIcon icon="services" mb={`${DESKTOP_SPACING.XXL}px`} title={`${name} ${amount ? " X" + amount : ""}`} />}
          showArrow
          state={accordionState}
        >
          { isAdmin &&  <OrderServiceHeader
                name={name}
                notificationMessage={notificationMessage}
                onAskToChangeWorker={onAskToChangeWorker}
                onNotifyCustomer={onNotifyCustomer}
                onRecordVirtualTour={onRecordVirtualTour}
                selectedWorkerName={selectedWorkerName}
                serviceId={serviceId}
                type={type} /> }

          <Grid columnGap={DESKTOP_SPACING.XL} gridTemplateColumns="repeat(2, 40%)" margin="0">
            <InputText
                type="text"
                label="Label"
                value={label}
                onChange={(e) => onChangeLabel?.(e.target.value, serviceId)}
              />
            <InputText
                type="text"
                label="External URL"
                value={externalUrl}
                onChange={(e) => onChangeUrl?.(e.target.value, serviceId)}
              />
          </Grid>
        </Accordion>
    </Card>
  );
}

export default memo(GenericService);